import React, { Component } from 'react';
import * as Table from 'reactabular-table';
import * as sort from 'sortabular';
import * as Search from 'searchtabular';
import { PageHeader, Grid, Row, Col, Pagination } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getContracts } from 'utils/ContractsAPIUtils';
import paginate from 'utils/pagination-util';
import Store from 'stores/ContractsStore';
import moment from 'moment-business-days';
import orderBy from 'lodash/orderBy';
export default class ContractList extends Component {
    constructor(props) {
        super(props);
        this.onPerPage = (e) => {
            const pagination = this.state.pagination || {};
            pagination.perPage = parseInt(e.target.value, 10);
            this.setState({
                pagination: pagination,
            });
        };
        this.state = this.getInitialState();
        this.onChange = () => this.onStoreChange();
    }
    getInitialState() {
        const getSortingColumns = () => this.state.sortingColumns || {};
        const sortable = sort.sort({
            getSortingColumns,
            onSort: (selectedColumn) => {
                this.setState({
                    sortingColumns: sort.byColumns({
                        // sort.byColumn would work too
                        sortingColumns: this.state.sortingColumns,
                        selectedColumn,
                    }),
                });
            },
        });
        return {
            editedCell: null,
            query: {},
            searchColumn: 'all',
            sortingColumns: null,
            formatters: {
                type: (type) => this.find([
                    { value: 'Carrier', name: 'Carrier' },
                    { value: 'Shipper', name: 'Shipper' },
                ], 'value', type).name,
            },
            columns: [
                {
                    property: 'contract_name',
                    header: {
                        label: 'ContractName',
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [
                            (value, extra) => (React.createElement("div", null,
                                React.createElement(Link, { to: `/addcontract/${extra.rowData._id}` }, Search.highlightCell(value, extra)))),
                        ],
                    },
                },
                {
                    property: 'parties',
                    header: {
                        label: 'Parties',
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [Search.highlightCell],
                    },
                },
                {
                    property: 'user_name',
                    header: {
                        label: 'Users',
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [Search.highlightCell],
                    },
                },
                {
                    property: 'start_date',
                    header: {
                        label: 'Start Date',
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [
                            (value) => moment(value).format('L'),
                            Search.highlightCell,
                        ],
                    },
                },
                {
                    property: 'expiration_date',
                    header: {
                        label: 'Expiration Date',
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [
                            (value) => moment(value).format('L'),
                            Search.highlightCell,
                        ],
                    },
                },
                {
                    property: 'status',
                    header: {
                        label: 'Status',
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [Search.highlightCell],
                    },
                },
            ],
            pagination: {
                page: 0,
                perPage: 10,
            },
        };
    }
    componentDidMount() {
        Store.addChangeListener(this.onChange);
        getContracts();
    }
    componentWillUnmount() {
        Store.removeChangeListener(this.onChange);
    }
    onStoreChange() {
        this.setState({ contracts: Store.getContracts() });
    }
    onSelect(eventKey) {
        var pagination = this.state.pagination || {};
        pagination.page = eventKey - 1;
        this.setState({
            pagination: pagination,
        });
    }
    render() {
        let contracts = this.state.contracts;
        const columns = this.state.columns;
        const searchColumn = this.state.searchColumn;
        const pagination = this.state.pagination;
        const query = this.state.query;
        const sortingColumns = this.state.sortingColumns;
        if (contracts && query) {
            contracts = Search.highlighter({
                columns: columns,
                matches: Search.matches,
                query,
            })(Search.multipleColumns({ columns, query })(contracts));
        }
        contracts = sort.sorter({
            columns: columns,
            sortingColumns,
            sort: orderBy,
        })(contracts);
        let totalPages = 0;
        if (pagination.perPage && contracts) {
            totalPages = Math.ceil(contracts.length / pagination.perPage);
        }
        const paginated = paginate(contracts, pagination);
        return (React.createElement("div", { className: "contract-wrapper" },
            React.createElement(PageHeader, null, "Contracts"),
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement("div", { style: { float: 'right', marginBottom: 10 } },
                        React.createElement(Link, { className: "btn btn-primary", to: "/addcontract/new" },
                            React.createElement("span", null, "Create Contract"))))),
            React.createElement(Grid, { fluid: true },
                React.createElement(Row, { className: "show-grid row-centered" },
                    React.createElement(Col, { xs: 4, className: "fixed col-left" },
                        React.createElement("label", null,
                            "Per page",
                            ' ',
                            React.createElement("input", { type: "number", value: this.state.pagination.perPage, onChange: this.onPerPage }))),
                    React.createElement(Col, { xs: 4, className: "col-centered" },
                        React.createElement("h4", null, `Page ${pagination.page + 1} of ${totalPages}`)),
                    React.createElement(Col, { xs: 4, className: "col-right" },
                        React.createElement("div", { className: "search-container" },
                            React.createElement("span", null, "Search"),
                            React.createElement(Search.Field, { column: searchColumn, query: query, columns: columns, rows: paginated.data, onColumnChange: (searchColumn) => this.setState({ searchColumn }), onChange: (query) => this.setState({ query }) }))))),
            React.createElement("div", null,
                React.createElement(Table.Provider, { className: "default-table", columns: columns },
                    React.createElement(Table.Header, null),
                    React.createElement(Table.Body, { rows: paginated.data, rowKey: "_id" }))),
            React.createElement("div", { className: "controls" },
                React.createElement(Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true, items: paginated.amount, maxButtons: 5, activePage: pagination.page + 1, onSelect: (eventKey) => this.onSelect(eventKey) }))));
    }
}
